import { getLocale } from './browser';
import type { Locale } from './locale';

const messages: Record<string, [string, string]> = {
  INVALID_CREDENTIALS: ['Email or password is incorrect.', 'ایمیل یا رمز عبور درست نیست.'],
  INCORRECT_PASSWORD: ['Your current password is incorrect.', 'رمز عبور فعلی درست نیست.'],
  SAME_PASSWORD: ['Choose a different password.', 'رمز عبور جدید باید با رمز قبلی متفاوت باشد.'],
  INVALID_TWO_FACTOR_CODE: ['The verification code is invalid.', 'کد تأیید معتبر نیست.'],
  INVALID_TOKEN: ['This link is invalid or expired.', 'این لینک معتبر نیست یا منقضی شده است.'],
  MISSING_TOKEN: ['Open the link from your email.', 'از لینک ارسال‌شده به ایمیل خود استفاده کنید.'],
  EXPIRED_CODE: [
    'This code has expired. Request a new one.',
    'کد منقضی شده است. کد جدیدی درخواست کنید.',
  ],
  UNVERIFIED_EMAIL: ['Verify your email before continuing.', 'ابتدا ایمیل خود را تأیید کنید.'],
  ACCOUNT_DISABLED: [
    'This account is disabled. Contact your administrator.',
    'این حساب غیرفعال است. با مدیر سازمان تماس بگیرید.',
  ],
  UNAUTHORIZED: ['You do not have access to this action.', 'اجازه انجام این کار را ندارید.'],
  SESSION_NOT_FOUND: ['Sign in to continue.', 'برای ادامه وارد حساب خود شوید.'],
  SESSION_EXPIRED: [
    'Your session expired. Sign in again.',
    'نشست شما پایان یافته است. دوباره وارد شوید.',
  ],
  ALREADY_EXISTS: ['This item already exists.', 'این مورد قبلاً ثبت شده است.'],
  NOT_FOUND: ['The requested item was not found.', 'مورد درخواستی پیدا نشد.'],
  TOO_MANY_REQUESTS: [
    'Too many attempts. Try again later.',
    'تعداد درخواست‌ها بیش از حد مجاز است. کمی بعد تلاش کنید.',
  ],
  LIMIT_EXCEEDED: ['You have reached the allowed limit.', 'به سقف مجاز رسیده‌اید.'],
  INVALID_BODY: ['Check the information you entered.', 'اطلاعات واردشده را بررسی کنید.'],
  INVALID_REQUEST: [
    'This request could not be completed. Check your information.',
    'انجام این درخواست ممکن نیست. اطلاعات خود را بررسی کنید.',
  ],
  SIGNUP_DISABLED: [
    'Registration is currently unavailable.',
    'در حال حاضر امکان ثبت‌نام وجود ندارد.',
  ],
};
export const errorMessage = (error: { code?: string }, locale: Locale = getLocale()) => {
  const pair = messages[error.code ?? ''] ?? [
    'Something went wrong. Please try again.',
    'مشکلی پیش آمد. لطفاً دوباره تلاش کنید.',
  ];
  return pair[locale === 'fa' ? 1 : 0]!;
};
